import {store} from "../Utils/stores";
let trialFlagSet = false;
store.subscribe($store => {
  if ($store.machinable_only) {
    trialFlagSet = true;
  } else {
    trialFlagSet  =  false;
  }
})

export function isOffline() {
  return PUBLIC_OFFLINE;
}

export function apiBaseURL() {
  return PUBLIC_API_BASE_URL;
}

export function supportsLogin() {
  return false;
}


export function trialMachinableOnly() {
  return /*PUBLIC_TRIAL_MACHINABLE_ONLY || */trialFlagSet
}
